import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  chatUser: null,
  chatGroup: null,
  chatMessages: [],
  chatGroupId: null,
  chatGroupMessages: [],
  replyToMessages: null,
  refetChatCount:null,
  refetchGroupList:null
};

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    setChatUser: (state, action) => {
      state.chatUser = action.payload.chatUser;
      state.chatGroup = action.payload.chatGroup;
    },
    setChatMessages: (state, action) => {
      state.chatMessages = action.payload.chatMessages;
      state.chatGroupMessages = action.payload.chatGroupMessages;
    },
    setChatGroupId: (state, action) => {
      state.chatGroupId = action.payload.chatGroupId;
     
    },
    setReplyToMessages: (state, action) => {
      state.replyToMessages = action.payload.replyToMessages;
    }, 
    setRefetChatCnt: (state, action) => {     
      state.refetChatCount = action.payload.chatCntUpdate;
    },
    setGroupListUpdate: (state, action) => {     
      state.refetchGroupList = action.payload.GroupListUpdate;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setChatUser } = chatSlice.actions;
export const { setChatGroup } = chatSlice.actions;
export const { setChatMessages } = chatSlice.actions;
export const { setChatGroupId } = chatSlice.actions;
export const { setChatGroupMessages } = chatSlice.actions;
export const { setReplyToMessages } = chatSlice.actions;
export const { setRefetChatCnt } = chatSlice.actions;
export const { setGroupListUpdate } = chatSlice.actions;


export const selectChatUser = (state) => state.chat.chatUser;
export const selectChatGroup = (state) => state.chat.chatGroup;
export const selectChatMessages = (state) => state.chat.chatMessages;
export const selectChatGroupId = (state) => state.chat.chatGroupId;
export const selectChatGroupMessages = (state) => state.chat.chatGroupMessages;
export const selectReplyToMessages = (state) => state.chat.replyToMessages;
export const selectRefetChatCount = (state) => state.chat.refetChatCount;
export const selectGroupListUpdate = (state) => state.chat.refetchGroupList;


export default chatSlice.reducer;
